import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";

const About = () => {
    const renderBanner = () => (
        <div className="position-relative bg-secondary" style={{ overflow: "hidden" }}>
            <img
                src="https://res.cloudinary.com/dbirahuue/image/upload/v1759158410/AboutImg_vgzapz.webp"
                className="img-fluid w-100"
                alt="Banner"
                style={{
                    objectFit: "cover",
                    maxHeight: "600px",
                    width: "100%",
                    mixBlendMode: "multiply",
                }}
            />
            <div
                className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
            >
                {/* Large screens */}
                <h2 className="d-none d-lg-block text-white text-center text-uppercase p-2  bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Vibha Enterprises</h2>
                <h5 className="d-none d-lg-block text-white text-center text-uppercase" data-aos="zoom-in" style={{letterSpacing: "10px"}}>Your Reliable Fastening Partner</h5>

                {/* Small/medium screens */}
                <h4 className="d-block d-lg-none p-2 text-white text-center text-uppercase bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Vibha Enterprises</h4>
                <h6 className="d-block d-lg-none text-white text-center text-uppercase" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Your Reliable Fastening Partner</h6>
            </div>
        </div>
    );

    const renderDetails = () => (
        <div className="px-3 pt-4 pb-0 pb-lg-3">
            <h4>About Us</h4>
            <div className="row justify-content-center text-wrap">
                {/* Left Content */}
                <div className="col-12 col-lg-8 text-justify">
                    <p className="text-muted mb-2">
                        Vibha Enterprises, established in 2017 and based in Moshi, Pune, is an ISO 9001:2015 certified company and a leading supplier, importer, and service provider of standard and special fasteners.
                    </p>
                    <p className="text-muted mb-2">
                        The company is committed to delivering customer-centric solutions and specializes in providing high-quality fasteners tailored to the automotive industry, with a strong focus on electric vehicle fasteners. Our comprehensive product range includes M5 Semi-Hex Nut Inserts, Self-Clinching Blind Nuts, Weld Nuts, and Special Stand-offs, ensuring reliable and high-performance solutions for evolving industry needs.
                    </p>
                    <p className="text-secondary fw-semibold mb-2">
                        Special Fasteners Engineered for High Performance and Safety
                    </p>
                    <p className="text-muted mb-0">
                        These specially designed fasteners are used in electric vehicles. They are engineered to meet the demanding requirements of Electric Vehicle applications, including high vibration resistance, corrosion protection, lightweight construction, and electrical insulation where required. These fasteners ensure reliable mounting, long-term durability, and safety of the battery pack under varying road and environmental conditions.
                    </p>
                </div>

                {/* Right Image */}
                <div className="col-10 col-lg-4 text-center">
                    <LazyLoadImage
                        src="https://res.cloudinary.com/dbirahuue/image/upload/v1759158951/About_babtkb.webp"
                        className="img-fluid rounded-4 w-100"
                        alt="About Vibha Enterprises"
                        effect="opacity"
                        style={{height: window.innerWidth <= 576 ? "240px" : "350px", objectFit: "contain"}}
                    />
                </div>
            </div>
        </div>
    );

    const renderAdditionalInfo = () => {
        return (
            <div className="px-3 pt-4 pb-5">
                <div className="row text-center">
                    <h4 className="text-uppercase mb-0" data-aos="fade-up">Our Vision & Mission</h4>
                    <p className="text-muted" data-aos="fade-up">What drives us forward</p>
                </div>

                <div className="row g-4">
                    {/* Vision Card */}
                    <div className="col-12 col-lg-6">
                        <div className="card rounded-0 shadow-sm backGround" data-aos="fade-up">
                            <div className="card-body">
                                <h5 className="card-title text-center mb-0">Vision</h5>
                                <p className="card-text text-center text-muted text-justify">Our vision is to be India’s most trusted importer of special fasteners, driving innovation through global collaborations. We are committed to supporting India’s shift toward sustainable mobility with reliable electric vehicle focused products, while setting new benchmarks for integrity and excellence in mission-critical applications.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Mission Card */}
                    <div className="col-12 col-lg-6">
                        <div className="card rounded-0 shadow-sm backGround" data-aos="fade-up">
                            <div className="card-body">
                                <h5 className="card-title text-center mb-0">Mission</h5>
                                <p className="card-text text-center text-muted text-justify">
                                    Our mission is to deliver world-class fastening solutions
                                    through advanced technology and global sourcing. We ensure
                                    reliability, safety, and durability in every product while
                                    building long-term customer partnerships and expanding across
                                    automotive, electronics, renewable energy, and defense sectors.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="container-fluid p-0">
            {renderBanner()}
            {renderDetails()}
            {renderAdditionalInfo()}
        </div>
    );
};

export default About;
